import styled from "styled-components";
import {colors} from "styles/colors";

export const FormRowWrapper = styled.div`
  border-bottom: 2px solid ${colors.primary};
  display: flex;
  flex-direction: column;
  padding: 12px;
  background-color: ${colors.primaryBg};
`